import {
    FormControlLabel,
    type FormControlLabelProps,
    Switch as MuiSwitch,
    SwitchProps
} from '@mui/material';

export type Props = SwitchProps & {
    label: React.ReactNode;
    labelPlacement?: FormControlLabelProps['labelPlacement'];
};

export const Switch = ({ label, checked, onChange, labelPlacement, ...props }: Props) => {
    return (
        <FormControlLabel
            control={<MuiSwitch {...props} checked={checked} onChange={onChange} />}
            label={label}
            labelPlacement={labelPlacement}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
                ...props.sx
            }}
        />
    );
};
